import gql from 'graphql-tag';
import PublicUserProfile from './public_user_profile';

export default gql`
  fragment LeaderboardScore on LeaderboardScore {
    leaderboard_config_id
    user_id
    user {
      ...PublicUserProfile
    }
    score
    ranking
    position_change
    events {
      event
      score
    }
  }
  ${PublicUserProfile}
`;
